export default __webpack_public_path__ + "static/media/17_2.0c52790d.jpg";